import Vue from 'vue';

import {
  PROPERTY_INFO_CURRENT_SET,
} from '../mutations-types'

const state = {
  propertyInfo: null
};

const getters = {
  propertyInfo: state => state.propertyInfo,
};

const mutations = {
  [PROPERTY_INFO_CURRENT_SET](state, data) {
    Vue.set(state, 'propertyInfo', data);
  },
};

const actions = {
  /**
   * NOTE: none
   * @URLParams
   * none
   * @BodyParams
   * none
   * **/
  PROPERTY_INFO_REQUEST_GET ({ state, commit }, listingId) {
    return new Promise((resolve, reject) => {
      if (state.propertyInfo && state.propertyInfo.id === listingId) {
        resolve();
      } else {
        Vue.axios.get('/listings/' + listingId)
          .then((response) => {
            let data = null;
            if (response.data.data.length > 0) {
              data = response.data.data[0];
            }
            commit(PROPERTY_INFO_CURRENT_SET, data);
            resolve();
          }).catch(error => {
          reject();
        });
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};